import { render, staticRenderFns } from "./PO.vue?vue&type=template&id=078f8aa6&"
import script from "./PO.vue?vue&type=script&lang=js&"
export * from "./PO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports